<template>
  <CrudList
      title="Usuarios y Mensajes Reportados"
      storeName="User_reports"
      labelAddNew="Agregar"
      sortable
      canSearch
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      next-link="/admin/notifications_cms"
      :breadcrumbs="[
      {
        text: 'Gestion de usuarios',
        disabled: false,
        href: '/admin/users_scroll'
      },
      {
        text: 'Usuarios y Mensajes Reportados',
        disabled: false,
        href: '#'
      }
    ]"
  >

    <!-- Usuario reportado -->
    <template v-slot:item.user_id.fullname="{ item }">
      {{ item.user_id?.fullname || 'N/A' }}
    </template>

    <!-- Usuario que reporta -->
    <template v-slot:item.reported_by_user_id.fullname="{ item }">
      {{ item.reported_by_user_id?.fullname || 'N/A' }}
    </template>

    <!-- Estado conversación -->
    <template v-slot:item.conversation_id.status="{ item }">
      <span
          :class="[
          'status-chip',
          item.conversation_id?.status === 'active'
            ? 'active'
            : 'finished'
        ]"
      >
        {{ item.conversation_id?.status || 'N/A' }}
      </span>
    </template>
    <template v-slot:created_at="{ item }">
      {{ formatDate(item.created_at) }}
    </template>
  </CrudList>
</template>


<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  methods: {
    formatDate(created_at) {
      if (!created_at) return null;
      let [date, time] = created_at.split("T");
      const [year, month, day] = date.split("-");
      time = (time.split(".")[0]);
      return `${day}/${month}/${year}`;
    },
  }
};
</script>

